export default __webpack_public_path__ + "static/media/img-guide-gt-popup-2-it_it@3x.6820d2ff.png";